export enum Colour {
  BLACK = 0x000000,
  WHITE = 0xffffff,
  GREEN = 0x00ff00,
  BLUE = 0x00ffff,
  ORANGE = 0xffd700,
  RED = 0xff0000,
}
